import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsTable from './StatisticsTable.js';
import {
    mainSelector,
    getHeaderName,
    getMetrics,
    getKeysMetric
} from './StatisticsTable.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector,
    headerName: getHeaderName,
    metrics: getMetrics,
    keysMetric: getKeysMetric
});

const StatisticsTableComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.statistics.data.loading
        };
    },
    null
)(StatisticsTable);

export default StatisticsTableComponent;
